module.exports = __webpack_public_path__ + "img/banner.54beae88.png";